/**
 * pages/naryad/register/naryadStore.js — Ажлын даалгаврын ажил ба ажилтан.
 *
 * ⚠ ЭХ СУРВАЛЖ НЬ БААЗ (2026-08-15-аас). Энэ модуль нь:
 *     • `*Backend` функцууд — API руу бичих ГОЛ зам (үүнийг хуудас дуудна),
 *     • бусад нь зөвхөн ЛОКАЛ КЭШ (жагсаалтыг хурдан харуулах, офлайн унших).
 *
 *   Урьд нь засах/устгах нь ЗӨВХӨН localStorage дээр ажилладаг байсан тул
 *   `syncNaryadJobsFromBackend()` дараагийн ачаалалтад жагсаалтыг backend-ийн
 *   хуулбараар дарж бичихэд засвар чимээгүй устаж, устгасан ажил буцаж
 *   гарч ирдэг байв. Кэш рүү шууд бичих ЗАМ ХААГДСАН.
 *
 * Бүтэц:
 *   Ажил (job):
 *     { id, yearc, department_code, department_name, section_code,
 *       section_name, jobdesc, comment, created_at, created_by,
 *       created_by_name, updated_at }
 *
 *   Ажилтан (worker):
 *     { id, naryad_id, work_date, tn, worker_name, position,
 *       destination, comment, checklist_5a_completed, checklist_5a_score,
 *       created_at, created_by, created_by_name, updated_at }
 */

const JOBS_KEY = "naryad_jobs_v1";
const WORKERS_KEY = "naryad_workers_v1";

const genId = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
};

const nowIso = () => new Date().toISOString();

const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const loadList = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const data = JSON.parse(raw);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};

const saveList = (key, list) => {
  try {
    localStorage.setItem(key, JSON.stringify(list));
  } catch {
    /* noop */
  }
};

// ── Ажил (Naryad Job) ─────────────────────────────────────────────────────

export const listNaryadJobs = () => loadList(JOBS_KEY);

// Backend-аас татаж localStorage-руу sync хийх (background)
export const syncNaryadJobsFromBackend = async () => {
  try {
    const mod = await import("src/api/hazard");
    const fetched = await mod.listNaryadJobsApi();
    if (Array.isArray(fetched)) {
      // Backend-ийн int id-г stringify хийж localStorage-руу overwrite
      const normalized = fetched.map((j) => ({
        ...j,
        id: String(j.id),
      }));
      // ⚠ localStorage-Д БИЧИХГҮЙ. Өмнө нь баазаас татсан жагсаалтыг
      //   локалд толилуулж, дараа нь тэндээс уншдаг байв. Тэр нь
      //   хуучирсан мөр амьд үлдэх, устгасан ажил дахин гарч ирэх
      //   эх үүсвэр болдог. Бааз бол цорын ганц эх сурвалж.
      return normalized;
    }
  } catch (ex) {
    console.warn("syncNaryadJobsFromBackend алдаа:", ex?.message);
  }
  return loadList(JOBS_KEY);
};

export const getNaryadJob = (id) =>
  loadList(JOBS_KEY).find((j) => j.id === id) || null;

export const addNaryadJob = (payload, creator = {}) => {
  const list = loadList(JOBS_KEY);
  const start = payload.start_date || payload.work_date || todayStr();
  const end = payload.end_date || start;
  const entry = {
    id: genId(),
    start_date: start,
    end_date: end,
    yearc: payload.yearc || String(new Date(start).getFullYear()),
    department_code: payload.department_code || "",
    department_name: payload.department_name || "",
    section_code: payload.section_code || "",
    section_name: payload.section_name || "",
    execution_department_code: payload.execution_department_code || "",
    execution_department_name: payload.execution_department_name || "",
    execution_section_code: payload.execution_section_code || "",
    execution_section_name: payload.execution_section_name || "",
    jobdesc: payload.jobdesc || "",
    comment: payload.comment || "",
    created_at: nowIso(),
    created_by: String(creator.tn || ""),
    created_by_name: creator.name || "",
    updated_at: nowIso(),
  };
  saveList(JOBS_KEY, [...list, entry]);
  return entry;
};

// Backend-руу ажил үүсгэх (DB-д хадгалах). Амжилттай үед буцсан item-ийг
// localStorage дотор update хийнэ.
export const addNaryadJobBackend = async (payload) => {
  const mod = await import("src/api/hazard");
  const res = await mod.createNaryadJobApi(payload);
  const item = res?.item || res;
  if (item) {
    const list = loadList(JOBS_KEY);
    const entry = {
      ...item,
      id: String(item.id),
      created_at: item.insert_date || item.created_at || nowIso(),
      created_by: String(item.insert_user_tn || ""),
      created_by_name: item.insert_user_name || "",
      updated_at: item.update_date || nowIso(),
    };
    saveList(JOBS_KEY, [...list, entry]);
    return entry;
  }
  throw new Error("Backend ажил үүсгэж чадсангүй");
};

/* ────────────────────────────────────────────────────────────────────────
   БААЗАД ХАДГАЛАХ ҮЙЛДЛҮҮД (2026-08-15)

   ⚠ Өмнө нь засах/устгах нь ЗӨВХӨН localStorage дээр ажилладаг байсан.
     `syncNaryadJobsFromBackend()` нь жагсаалтыг backend-ийн хуулбараар
     БҮРЭН дарж бичдэг тул хуудас дахин ачаалмагц засвар чимээгүй
     алга болж, устгасан ажил буцаж гарч ирдэг байв. Өөр хэрэглэгч
     засварыг огт харахгүй.

   Одоо: СЕРВЕР ЭЗЭН. Эхлээд API руу бичиж, амжилттай болсны дараа л
   локал кэшийг шинэчилнэ. API алдвал алдаа дээшээ шидэгдэнэ —
   «хадгалагдлаа» гэж худал мэдэгдэхгүй.
──────────────────────────────────────────────────────────────────────── */

/** Ажил засах — DB. Амжилттай бол локал кэшийг мөн шинэчилнэ. */
export const updateNaryadJobBackend = async (id, patch) => {
  const mod = await import("src/api/hazard");
  await mod.updateNaryadJobApi(id, patch);
  return updateNaryadJob(id, patch);
};

/**
 * Ажил устгах — DB (soft delete).
 *
 * ⚠ ХАРЬЯА АЖИЛТНУУДЫГ УРЬДААР устгана: наряд ажлыг устгахад
 *   `oea_worker_registrations` дэх бүртгэл нь backend дээр АВТОМАТААР
 *   хаагддаггүй тул тэр ажилтан `/me` хуудсан дээрээ устсан ажлын
 *   даалгаврыг хараад л байх болно.
 *
 * @param {Array} workers — тухайн ажилд харьяалагдах ажилтнууд (UI-аас)
 */
export const deleteNaryadJobBackend = async (id, workers = []) => {
  const mod = await import("src/api/hazard");
  for (const w of workers) {
    const oeaId = oeaRegistrationId(w);
    if (oeaId) await mod.deleteOeaRegistration(oeaId);
  }
  await mod.deleteNaryadJobApi(id);
  deleteNaryadJob(id);
};

/**
 * Ажилтны мөрөөс ӨЭА бүртгэлийн ДУГААРЫГ салгаж авна.
 *
 * Backend нь ажилтныг `vw-<id>` гэсэн түлхүүртэйгээр буцаадаг
 * (Resources/mobile/naryad_job.py). Локал (хуучин) мөр нь UUID-тай тул
 * баазад холбогдох мөр БАЙХГҮЙ — тэр үед `null` буцна.
 */
export const oeaRegistrationId = (w) => {
  const m = /^vw-(\d+)$/.exec(String(w?.id || ""));
  return m ? Number(m[1]) : null;
};

/** Ажилтан засах — ӨЭА бүртгэл дээр. */
export const updateNaryadWorkerBackend = async (worker, patch) => {
  const oeaId = oeaRegistrationId(worker);
  if (!oeaId) {
    // Баазад мөргүй хуучин локал бичлэг — DB рүү бичих зүйлгүй
    return updateNaryadWorker(worker.id, patch);
  }
  const mod = await import("src/api/hazard");
  await mod.updateOeaRegistration(oeaId, {
    work_date: patch.work_date,
    tn: patch.tn,
    worker_name: patch.worker_name,
    position: patch.position,
    destination: patch.destination,
  });
  return updateNaryadWorker(worker.id, patch);
};

/** Ажилтан устгах — ӨЭА бүртгэлийг soft delete. */
export const deleteNaryadWorkerBackend = async (worker) => {
  const oeaId = oeaRegistrationId(worker);
  if (oeaId) {
    const mod = await import("src/api/hazard");
    await mod.deleteOeaRegistration(oeaId);
  }
  deleteNaryadWorker(worker.id);
};

/* ── Локал КЭШИЙН үйлдлүүд ────────────────────────────────────────────
   ⚠ Эдгээрийг ХУУДАСНААС ШУУД дуудахгүй — зөвхөн дээрх backend
     функцууд дотроос, DB-д амжилттай бичсэний дараа кэш засахад. */

export const updateNaryadJob = (id, patch) => {
  const list = loadList(JOBS_KEY);
  const idx = list.findIndex((j) => j.id === id);
  if (idx < 0) return null;
  const next = {
    ...list[idx],
    ...patch,
    id: list[idx].id,
    created_at: list[idx].created_at,
    updated_at: nowIso(),
  };
  list[idx] = next;
  saveList(JOBS_KEY, list);
  return next;
};

export const deleteNaryadJob = (id) => {
  saveList(
    JOBS_KEY,
    loadList(JOBS_KEY).filter((j) => j.id !== id),
  );
  // Cascade — энэ ажилд бүртгэлтэй ажилтнуудыг ч устгана
  saveList(
    WORKERS_KEY,
    loadList(WORKERS_KEY).filter((w) => w.naryad_id !== id),
  );
};

// ── Ажилтан (Worker registered to Job) ────────────────────────────────────

export const listNaryadWorkers = (naryadId) => {
  const all = loadList(WORKERS_KEY);
  if (!naryadId) return all;
  return all.filter((w) => w.naryad_id === naryadId);
};

export const addNaryadWorker = (payload, creator = {}) => {
  const list = loadList(WORKERS_KEY);
  const entry = {
    id: genId(),
    naryad_id: payload.naryad_id || null,
    work_date: payload.work_date || todayStr(),
    tn: String(payload.tn || ""),
    worker_name: payload.worker_name || "",
    position: payload.position || "",
    destination: payload.destination || "",
    comment: payload.comment || "",
    checklist_5a_completed: !!payload.checklist_5a_completed,
    checklist_5a_score: payload.checklist_5a_score || 0,
    created_at: nowIso(),
    created_by: String(creator.tn || ""),
    created_by_name: creator.name || "",
    updated_at: nowIso(),
  };
  saveList(WORKERS_KEY, [...list, entry]);
  return entry;
};

export const updateNaryadWorker = (id, patch) => {
  const list = loadList(WORKERS_KEY);
  const idx = list.findIndex((w) => w.id === id);
  if (idx < 0) return null;
  const next = {
    ...list[idx],
    ...patch,
    id: list[idx].id,
    created_at: list[idx].created_at,
    updated_at: nowIso(),
  };
  list[idx] = next;
  saveList(WORKERS_KEY, list);
  return next;
};

export const deleteNaryadWorker = (id) => {
  saveList(
    WORKERS_KEY,
    loadList(WORKERS_KEY).filter((w) => w.id !== id),
  );
};

/**
 * Тухайн ТН-аар (мөн заавал биш огноогоор) Ажлын даалгаврын ажилтны
 * бүртгэлийг хайх. Хэрэв олдвол `worker` объект болон харьяалагдах `job`
 * объектыг буцаана.
 *
 * Жишээ:
 *   const reg = findByTn("12345");
 *   // reg = { worker, job } эсвэл null
 */
export const findByTn = (tn, dateStr) => {
  if (!tn) return null;
  const norm = String(tn).trim();
  const day = dateStr || todayStr();
  const worker = loadList(WORKERS_KEY).find(
    (w) =>
      String(w.tn || "").trim() === norm && w.work_date === day,
  );
  if (!worker) return null;
  const job = loadList(JOBS_KEY).find((j) => j.id === worker.naryad_id) || null;
  return { worker, job };
};

export { todayStr };
